export const PendingChangesRecalculatedCardTestIds = {
  CARD: 'pending-changes-recalculated-card.container',
};
